import svc from '@/core/svc-client';
import { DateTime } from 'luxon';

export default {
  namespaced: true,

  state: {
    schedule: {},
    error: [],
  },

  getters: {
    schedule: state => {
      const { schedule } = state;
      return schedule;
    },
  },

  mutations: {
    setSchedule(state, payload) {
      console.log('setSchedule: ', payload);

      let offerData = {};

      if (payload && payload._metadata && payload._metadata.offer)
        offerData = payload._metadata.offer;

      // format date
      const shiftStartTime = DateTime.fromJSDate(new Date(payload.startTime));
      const shiftEndTime = DateTime.fromJSDate(new Date(payload.endTime));
      const timediff = shiftEndTime.diff(shiftStartTime, 'hours').toObject();

      // format ways to display time
      const displayDate = shiftStartTime.toFormat('ccc, d LLL');
      const displayStart =
        shiftStartTime.toFormat('mm') == '00'
          ? shiftStartTime.toFormat('h')
          : shiftStartTime.toFormat('h:mm');
      const displayStartAmPm =
        shiftStartTime.toFormat('a').toLowerCase() ==
        shiftEndTime.toFormat('a').toLowerCase()
          ? ''
          : shiftStartTime.toFormat('a').toLowerCase();
      const displayEndTime =
        shiftEndTime.toFormat('mm') == '00'
          ? shiftEndTime.toFormat('h')
          : shiftEndTime.toFormat('h:mm');

      const displayTime =
        displayStart +
        displayStartAmPm +
        ' - ' +
        displayEndTime +
        shiftEndTime.toFormat('a').toLowerCase() +
        ' (' +
        timediff.hours +
        'hr)';

      const offerDetails = {
        Owner: offerData._metadata.creator.firstName,
        Date: displayDate,
        Location: payload.locationName,
        Time: displayTime,
        Accepted: offerData.state === 'ACCEPTED_STATE' ? true : false,
        AcceptedBy: offerData._metadata.acceptedApplicant
          ? offerData._metadata.acceptedApplicant.fullName
          : '',
      };
      state.schedule = offerDetails;
    },
    setError(state, payload) {
      state.error.push(payload);
    },
  },

  actions: {
    async getSchedule({ commit }, payload) {
      try {
        // mock data for QA
        // const schedule = mockSchedule;
        const schedule = await svc.offer.get(payload);
        console.log('offer.get schedule: ', schedule);
        commit('setSchedule', schedule);
      } catch (e) {
        console.error(e);
        commit('setError', e);
        throw e;
      }
    },

    async postAccept({ commit }, payload) {
      // ajax call to post
      console.log('payload: ', payload);
      try {
        const response = await svc.offer.post(payload);
        commit('setSchedule', response);
      } catch (e) {
        commit('setError', e);
        throw e;
      }
    },
  },
};
